import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import {
  campaignData,
  certificateData,
  paidCertificate,
  certificatesCount,
  purchaseMessage,
} from '../../redux/landing/selectors';

import SuccessCertificatePage from './NewSuccessCertificatePage';

const selector = createStructuredSelector({
  campaignData,
  certificateData,
  paidCertificate,
  certificatesCount,
  purchaseMessage,
});

const actions = {};

export { SuccessCertificatePage };

export default connect(selector, actions)(SuccessCertificatePage);
